// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Motion$LiteracyplanetTupperware from "./Motion.res.mjs";
import * as TickIcon$LiteracyplanetTupperware from "../v2/TickIcon.res.mjs";
import * as CrossIcon$LiteracyplanetTupperware from "../v2/CrossIcon.res.mjs";
import * as V3RevealApi$LiteracyplanetTupperware from "./V3RevealApi.res.mjs";
import * as V3ClozeBucketProvider$LiteracyplanetTupperware from "./V3ClozeBucketProvider.res.mjs";

var overClassName = "pilotClozeBucketContainerOver";

var dropClassName = "pilotClozeBucketContainer";

function renderDragOverlayComponent(children) {
  return React.createElement("div", {
              className: "pilotClozeBucketOverlayItem cursor-pointer"
            }, children);
}

function renderCorrectDroppedComponent(onClick, children) {
  return React.createElement("div", {
              className: "pilotClozeBucketCorrect",
              onClick: onClick
            }, React.createElement("div", {
                  className: "pilotClozeBucketProviderMarkContainer"
                }, React.createElement(TickIcon$LiteracyplanetTupperware.make, {
                      className: "w-5 h-5 fill-lpTick"
                    })), children);
}

function renderIncorrectDroppedComponent(onClick, children) {
  return React.createElement("div", {
              className: "pilotClozeBucketIncorrect",
              onClick: onClick
            }, React.createElement("div", {
                  className: "pilotClozeBucketProviderMarkContainer"
                }, React.createElement(CrossIcon$LiteracyplanetTupperware.make, {
                      className: "w-5 h-5 fill-lpCross"
                    })), children);
}

function renderDragComponent(onClick, children) {
  return React.createElement(Motion$LiteracyplanetTupperware.Div.make, {
              layout: true,
              children: Caml_option.some(children)
            });
}

function PilotClozeBucketProvider$Reveal(props) {
  var match = Curry._1(V3RevealApi$LiteracyplanetTupperware.use, undefined);
  return Curry._1(props.children, match.reveal);
}

var Reveal = {
  make: PilotClozeBucketProvider$Reveal
};

function renderAlreadyDraggedAndMarkedPlaceholder(onClick, children) {
  return React.createElement(PilotClozeBucketProvider$Reveal, {
              children: (function (reveal) {
                  switch (reveal) {
                    case "DontHideItems" :
                        return React.createElement("div", {
                                    className: "pilotClozeDroppedItemOriginalCopy",
                                    onClick: onClick
                                  }, children);
                    case "Hide" :
                    case "RevealOneAtATime" :
                        return null;
                    
                  }
                })
            });
}

function renderAlreadyDraggedPlaceholder(onClick, children) {
  return React.createElement(PilotClozeBucketProvider$Reveal, {
              children: (function (reveal) {
                  switch (reveal) {
                    case "DontHideItems" :
                        return React.createElement("div", {
                                    className: "pilotClozeDroppedItemOriginalCopy cursor-pointer",
                                    onClick: onClick
                                  }, children);
                    case "Hide" :
                    case "RevealOneAtATime" :
                        return null;
                    
                  }
                })
            });
}

function renderUndroppedMarkedComponent(onClick, children) {
  return React.createElement("div", {
              className: "pilotClozeDragBucketItem"
            }, children);
}

function renderDroppedComponent(onClick, children) {
  return React.createElement("button", {
              className: "pilotClozeDroppedItem",
              onClick: onClick
            }, children);
}

function PilotClozeBucketProvider(props) {
  return React.createElement(V3ClozeBucketProvider$LiteracyplanetTupperware.make, {
              overClassName: overClassName,
              dropClassName: dropClassName,
              renderDragComponent: renderDragComponent,
              renderDragOverlayComponent: renderDragOverlayComponent,
              renderAlreadyDraggedPlaceholder: renderAlreadyDraggedPlaceholder,
              renderAlreadyDraggedAndMarkedPlaceholder: renderAlreadyDraggedAndMarkedPlaceholder,
              renderDroppedComponent: renderDroppedComponent,
              renderCorrectDroppedComponent: renderCorrectDroppedComponent,
              renderIncorrectDroppedComponent: renderIncorrectDroppedComponent,
              renderUndroppedMarkedComponent: renderUndroppedMarkedComponent,
              questionIndex: props.questionIndex,
              reveal: props.reveal,
              children: props.children
            });
}

var make = PilotClozeBucketProvider;

var $$default = PilotClozeBucketProvider;

export {
  overClassName ,
  dropClassName ,
  renderDragOverlayComponent ,
  renderCorrectDroppedComponent ,
  renderIncorrectDroppedComponent ,
  renderDragComponent ,
  Reveal ,
  renderAlreadyDraggedAndMarkedPlaceholder ,
  renderAlreadyDraggedPlaceholder ,
  renderUndroppedMarkedComponent ,
  renderDroppedComponent ,
  make ,
  $$default as default,
}
/* react Not a pure module */
